"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../../assets/js/constants");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var defaultProps = {
  items: [],
  multiply: false,
  name: '',
  onChange: function onChange() {
    return;
  },
  onLoad: function onLoad() {
    return;
  }
};
var propTypes = {
  items: _propTypes["default"].array,
  multiply: _propTypes["default"].bool,
  name: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func,
  onLoad: _propTypes["default"].func
};

var FilterContainer = _styledComponents["default"].form.withConfig({
  displayName: "filter__FilterContainer",
  componentId: "sc-1wf1gag-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    display: flex;\n    padding-left: 1px;\n    z-index: 0;\n\n    @media only screen and (max-width: 767px) {\n        width: 100%;\n    }\n"])));

var FilterItem = _styledComponents["default"].label.withConfig({
  displayName: "filter__FilterItem",
  componentId: "sc-1wf1gag-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    cursor: pointer;\n    margin-left: -1px;\n    user-select: none;\n\n    @media only screen and (max-width: 767px) {\n        flex-grow: 1;\n        flex-shrink: 0;\n    }\n"])));

var FilterTitle = _styledComponents["default"].span.withConfig({
  displayName: "filter__FilterTitle",
  componentId: "sc-1wf1gag-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    align-items: center;\n    box-sizing: border-box;\n    display: flex;\n    font: 400 16px/49px \"Roboto\", sans-serif;\n    justify-content: center;\n    padding: 0 22px;\n    position: relative;\n    height: 49px;\n    z-index: 5;\n\n    @media only screen and (max-width: 767px) {\n        padding: 0 5px;\n    }\n\n    &::after {\n        border: 1px solid ", ";\n        content: \"\";\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        right: 0;\n        left: 0;\n        z-index: 10;\n    }\n"])), _constants.COLORS.grey);

var FilterInput = _styledComponents["default"].input.withConfig({
  displayName: "filter__FilterInput",
  componentId: "sc-1wf1gag-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    display: none;\n\n    &:checked {\n        & + ", " {\n            z-index: 10;\n\n            &::after {\n                border-color: ", ";\n                border-width: 2px;\n            }\n        }\n    }\n"])), FilterTitle, _constants.COLORS.lightGreen);

var Filter = /*#__PURE__*/function (_Component) {
  _inherits(Filter, _Component);

  var _super = _createSuper(Filter);

  function Filter(props) {
    var _this;

    _classCallCheck(this, Filter);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "onChange", function (callback, event) {
      var formNode = _this.formRef.current;

      var inputNodes = _toConsumableArray(formNode.querySelectorAll('input'));

      var customEvent = {};

      if (event && !_this.props.multiply) {
        var count = inputNodes.reduce(function (acc, node) {
          if (node.checked) acc += 1;
          return acc;
        }, 0);

        if (count > 1) {
          inputNodes.forEach(function (node) {
            return node.checked = false;
          });
          event.target.checked = true;
        }
      }

      inputNodes.forEach(function (inputNode) {
        customEvent[inputNode.value] = inputNode.checked;
      });
      callback(customEvent);
    });

    _this.formRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }

  _createClass(Filter, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onChange(this.props.onLoad);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var labels = this.props.items.map(function (item) {
        return /*#__PURE__*/_react["default"].createElement(FilterItem, {
          key: item.value
        }, /*#__PURE__*/_react["default"].createElement(FilterInput, {
          defaultChecked: item.checked,
          name: _this2.props.name,
          type: "checkbox",
          value: item.value
        }), /*#__PURE__*/_react["default"].createElement(FilterTitle, null, item.label));
      });
      return /*#__PURE__*/_react["default"].createElement(FilterContainer, {
        onChange: function onChange(event) {
          _this2.onChange(_this2.props.onChange, event);
        },
        ref: this.formRef
      }, labels);
    }
  }]);

  return Filter;
}(_react.Component);

exports["default"] = Filter;

_defineProperty(Filter, "propTypes", propTypes);

_defineProperty(Filter, "defaultProps", defaultProps);